import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import client from "./appwriteConfig";
import { FaShoppingCart } from "react-icons/fa";
import { useUser } from "./UserContext";
import { Databases, Query } from "appwrite";
import "./css/SeperateBeat.css";
import { BeatLoader } from "react-spinners";
import { BsInfoCircle, BsPauseFill, BsPlayFill } from "react-icons/bs";
import ShareButton from "./ShareButton";

function SeparateBeat() {
  const { beatName } = useParams();
  const navigate = useNavigate();
  const [beatInfo, setBeatInfo] = useState(null);
  const [infoVisible, setInfoVisible] = useState(false);
  const [selectedTier, setSelectedTier] = useState("basic");
  const audioRef = useRef(new Audio());
  const {
    addToCart,
    cart,
    fetchCartData,
    user,
    currentTrack,

    isPlaying,
    togglePlay,
    startPlaylist,
  } = useUser();

  const cost =
    selectedTier === "basic" ? beatInfo?.basicCost : beatInfo?.premiumCost;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const fetchBeatInfo = async () => {
      try {
        const database = new Databases(client, "default");
        const sanitizedTitle = beatName.replace(/-/g, " ");
        const { documents } = await database.listDocuments(
          process.env.REACT_APP_DATABASE_ID,
          process.env.REACT_APP_COLLECTION_BEATS_ID,
          [Query.equal("beatName", sanitizedTitle)],
        );
        if (documents.length > 0) {
          setBeatInfo(documents[0]);
          audioRef.current.src = documents[0].lowAudioUrl;
        }
      } catch (error) {
        console.error("Failed to fetch beat info", error);
      }
    };

    fetchBeatInfo();
  }, [beatName]);

  useEffect(() => {
    if (user) {
      fetchCartData();
    }
  }, [user]);

  const isInCart = (productId) =>
    cart.some((item) => item.productId === productId);

  const handleAddToCart = () => {
    const product = {
      ...beatInfo,
      productType: "beat",
      cost: cost,
      tier: selectedTier,
    };
    addToCart(product);
  };

  const handleBuyNow = () => {
    const cartProduct = {
      ...beatInfo,
      productType: "beat",
      cost,
      tier: selectedTier,
    };

    addToCart(cartProduct);

    const enrichedCartProduct = {
      ...cartProduct,
      quantity: 1,
      totalCost: cost,
      productId: beatInfo.$id,
      productName: beatInfo.beatName,
      imageUrl: beatInfo.imageUrl,
      sellerEmail: beatInfo.email,
      BEATinfo: JSON.stringify({
        beatId: beatInfo.$id,
        beatName: beatInfo.beatName,
        artistName: beatInfo.artistName,
        cost,
        sellerEmail: beatInfo.email,
      }),
    };

    navigate("/checkout", {
      state: {
        cart: [enrichedCartProduct],
        totalPrice: cost,
      },
    });
  };

  const handlePlayPause = () => {
    if (!beatInfo) return;

    if (currentTrack && currentTrack.$id === beatInfo.$id) {
      togglePlay();
    } else {
      startPlaylist([beatInfo], beatInfo);
    }
  };

  if (!beatInfo)
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <BeatLoader color="#3498db" />
      </div>
    );

  const toggleInfo = () => setInfoVisible(!infoVisible);
  return (
    <div className="separate-beat-container">
      <div className="seperate-title">
        <h1>{beatInfo.beatName}</h1>
        <ShareButton />
        <button onClick={toggleInfo} className="info-btn">
          <BsInfoCircle />
        </button>{" "}
        {infoVisible && (
          <div className="info-message-seperate">
            This audio playing is a low-quality file. After buying, the full
            quality file will be available.
          </div>
        )}
      </div>
      <div className="beat-image-container">
        <img src={beatInfo.imageUrl} alt={beatInfo.beatName} />
        <button
          onClick={(e) => {
            e.stopPropagation();
            handlePlayPause();
          }}
          className="play-button-home"
        >
          {currentTrack && currentTrack.$id === beatInfo.$id && isPlaying ? (
            <BsPauseFill />
          ) : (
            <BsPlayFill />
          )}
        </button>
      </div>
      <div className="beatinfo-details">
        <p>
          <label>Artist:</label> {beatInfo.artistName}
        </p>
        <p>
          <label>Tempo:</label> {beatInfo.bpm} bpm
        </p>
        <p>
          <label>Genre:</label> {beatInfo.genre}
        </p>
      </div>{" "}
      <div className="addBeatModal-tierSelector">
        <div
          className={`tier-option ${
            selectedTier === "basic" ? "selected" : ""
          }`}
          onClick={() => setSelectedTier("basic")}
        >
          <div className="tier-title">Basic</div>
          <div className="tier-desc">WAV / MP3</div>
          <div className="tier-price">₹{beatInfo.basicCost}</div>
        </div>
        {beatInfo.stems && JSON.parse(beatInfo.stems).length > 0 && (
          <div
            className={`tier-option ${
              selectedTier === "premium" ? "selected" : ""
            }`}
            onClick={() => setSelectedTier("premium")}
          >
            <div className="tier-title">Premium</div>
            <div className="tier-desc">WAV + Stems</div>
            <div className="tier-price">₹{beatInfo.premiumCost}</div>
          </div>
        )}
      </div>{" "}
      <div className="buyadd-button">
        <button className="addBeatModal-button" onClick={handleAddToCart}>
          ADD <FaShoppingCart />: ₹{cost}
        </button>
        <button className="buyNow-button" onClick={handleBuyNow}>
          BUY NOW: ₹{cost}
        </button>
      </div>
    </div>
  );
}

export default SeparateBeat;
